qw-book {
  display: flex;
  flex-direction: column;
  position: relative;
}

.qw-book__mandatory-info {
  font-size: 16px;
  margin: 8px 0 7px;
  color: var(--qw-hotel-neutral-extra-label);
}

.qw-basket--taxes-info {
  font-family: var(--qw-hotel-font-family-r);
  text-align: right;
  text-decoration: underline;
  font-size: 12px;
  margin: 2px 16px 0;
  text-transform: lowercase;
  cursor: pointer;
  align-self: flex-end;
}

qw-book .basket-skeleton {
  transform: translateY(0px);
}

qw-book > * {
  opacity: 0;
  transform: translateY(40px);
}

qw-book.visualize-quote {
  justify-content: initial;
}
qw-book.visualize-quote > * {
  opacity: 1;
  transform: translateY(0px);
  transition:
    transform 0.6s cubic-bezier(0, 0.55, 0.45, 1),
    opacity 0.3s ease-in-out 0.2s;
}

qw-book .qw-loader {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.8;
  pointer-events: none;
  z-index: 2000;
}

qw-book .qw-loader:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 12%,
    white 17%,
    rgba(255, 255, 255, 0) 22%
  );
  background-size: 600% 100%;
  background-position-x: 40%;
  animation: 3s shine linear infinite;
  opacity: 0.4;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

qw-book.loading-skeleton .qw-book__wrapper {
  display: flex;
  flex-direction: column;
}

qw-book.loading-skeleton .qw-book__guest-details,
qw-book.loading-skeleton .qw-book__terms,
qw-book.loading-skeleton .qw-book__customer-details-wrapper {
  background-color: var(--qw-hotel-skeleton-light);
  box-shadow: none;
  position: relative;
}

qw-book.loading-skeleton .qw-book__heading h3 {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
}
qw-book.loading-skeleton .qw-book__heading .qw-book__arrow {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
  background-size: 0;
}

qw-book.loading-skeleton h3:first-of-type {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
  align-self: flex-start;
}
qw-book.loading-skeleton .qw-book__mandatory-info {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  border-radius: 2px;
  align-self: flex-start;
}

qw-book.loading-skeleton .qw-book--form-row .qw-select__label,
qw-book.loading-skeleton .qw-book--form-row .qw-input__label {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
  display: inline-block;
}

qw-book.loading-skeleton qw-input input,
qw-book.loading-skeleton select {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  border-radius: 2px;
  border-color: var(--qw-hotel-skeleton-medium);
  background-size: 0;
}

qw-book.loading-skeleton .iti__flag-container {
  display: none;
}

qw-book.loading-skeleton .qw-book__confirmation,
qw-book.loading-skeleton .qw-book__pay {
  display: none;
}

.qw-book__wrapper,
.qw-book__error-quote {
  padding: 0;
}

qw-book .qw-book__customer-details-wrapper {
  padding: 32px 33px 48px 30px;
  background-color: var(--qw-hotel-neutral-lightest);
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
}

qw-book .qw-book__customer-details-wrapper h3 {
  margin-bottom: 8px;
}

qw-book .qw-book__guest-details,
qw-book .qw-book__terms {
  margin-top: 40px;
  padding: 0;
  background-color: var(--qw-hotel-neutral-lightest);
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
}

qw-book .qw-book__guest-details .qw-book__heading,
qw-book .qw-book__terms .qw-book__heading {
  padding: 27px 40px;
}
qw-book .qw-book__guest-details .qw-book__content,
qw-book .qw-book__terms .qw-book__content {
  padding: 0 40px;
}

qw-book h3 {
  font-family: var(--qw-hotel-font-family-b);
  color: var(--qw-hotel-neutral-medium);
  font-size: 30px;
  margin: 0;
}

qw-book .qw-book__heading {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

qw-book .qw-book__heading h3 {
  font-family: var(--qw-hotel-font-family-b);
  color: var(--qw-hotel-neutral-medium);
  font-size: 21px;
}

.qw-book__error-quote {
  border: 1px solid var(--qw-hotel-accent-color);
}

.qw-book__special-requests__title {
  display: flex;
}

.qw-book__special-requests__title h4 {
  margin-right: var(--qw-hotel-gap-md);
}

.qw-book__special-requests__caption {
  font-size: 70%;
  margin-bottom: var(--qw-hotel-gap-md);
}

.qw-book__confirmation-checkbox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 14px;
}
.label__promoSubscription,
.label__confirmConditions {
  cursor: pointer;
}

.qw-book__confirmation-checkbox qw-input {
  width: auto;
}

.qw-book__guest-detail {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.qw-book__form-error {
  margin-top: var(--qw-hotel-gap-md);
  padding: var(--qw-hotel-gap-sm);
  border: 1px solid var(--qw-hotel-accent-color);
}

.qw-book__form-error > ul {
  padding-inline-start: var(--qw-hotel-gap-lg);
}

.qw-book__pay {
  margin-top: var(--qw-hotel-gap-md);
}

.qw-book__arrow {
  display: block;
  width: 15px;
  height: 15px;
  background-image: url('#{$base-url}img/icons/arrow-dropdown-grey.svg');
  background-size: 15px;
  background-position: 98% center;
  background-repeat: no-repeat;
  transition: all 0.3s ease;
}

.qw-book__arrow--rotate {
  transform: rotate(180deg);
}

.qw-book--form-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.qw-book--form-row .qw-select__label,
.qw-book--form-row .qw-select__label,
.qw-book--form-row .qw-input__label {
  font-family: var(--qw-hotel-font-family-m);
  color: var(--qw-hotel-neutral-medium);
  font-size: 18px;
  margin: 0 0 10px;
}

qw-book select {
  border: none;
  font-family: var(--qw-hotel-font-family-r);
  color: var(--qw-hotel-neutral-medium);
  font-size: 20px;
  padding: 10px 40px 13px 10px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #fff;
  background-image: url('#{$base-url}img/icons/arrow-dropdown-grey.svg');
  background-repeat: no-repeat;
  background-position: right 0.7em top 50%;
  background-size: 0.75em;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
  width: 100%;
  border: 1px solid #bfc0c0;
}

qw-book .qw-input__caption {
  display: none;
}

qw-book qw-input input {
  padding: 10px 10px 13px;
  font-family: var(--qw-hotel-font-family-r);
  color: var(--qw-hotel-neutral-medium);
  font-size: 20px;
  border: 1px solid #bfc0c0;
}

qw-book .qw-book__customer-details-wrapper .qw-select__title {
  flex-basis: 20%;
}

qw-book .qw-book__customer-details-wrapper .qw-input__firstName {
  flex-basis: 34%;
}

qw-book .qw-book__customer-details-wrapper .qw-input__lastName {
  flex-basis: 34%;
}

qw-book .qw-input__emailAddress,
qw-book .qw-book--form-row:last-of-type {
  margin-top: 32px;
}

qw-book .qw-input__phone {
  flex-basis: 50%;
}

qw-book .qw-select__countryCode {
  flex-basis: 34%;
}

qw-book .qw-book__confirmation {
  margin-top: 52px;
}

qw-book
  .qw-book__confirmation
  .qw-book__confirmation-checkbox
  .qw-input__label {
  display: none;
}

qw-book .qw-book__confirmation qw-input input[type='checkbox'] {
  width: 24px;
  height: 24px;
  border: 3px solid var(--qw-hotel-neutral-medium);
  padding: 0;
  border-radius: 3px;
  outline: none;
}

qw-book .qw-book__confirmation qw-input + div {
  font-size: 20px;
  font-family: var(--qw-hotel-font-family-r);
  color: var(--qw-hotel-neutral-medium);
  padding-left: 14px;
}

qw-book .qw-book__content .qw-book__guest-detail {
  margin-bottom: 58px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

qw-book .qw-book__content .qw-book__guest-detail h3 {
  margin: 30px 44px 58px 0;
  font-family: var(--qw-hotel-font-family-m);
  font-size: 21px;
}

qw-book .qw-book__other-info-content qw-textarea textarea {
  border: 1px solid #bfc0c0;
}

qw-book .qw-book__content .qw-book__guest-detail .qw-book__guest-detail--info {
  flex: 1;
}

qw-book
  .qw-book__content
  .qw-book__guest-detail
  .qw-book__guest-detail--info
  .qw-book--form-row {
  flex: 1;
  justify-content: flex-start;
}
qw-book
  .qw-book__content
  .qw-book__guest-detail
  .qw-book__guest-detail--info
  .qw-book--form-row:first-of-type {
  flex-direction: row;
}
qw-book
  .qw-book__content
  .qw-book__guest-detail
  .qw-book__guest-detail--info
  .qw-book--form-row
  .qw-select__Type {
  margin-left: 32px;
}

qw-book
  .qw-book__content
  .qw-book__guest-detail
  .qw-book__guest-detail--info
  .qw-book--form-row
  .qw-select__label {
  font-size: 16px;
}

qw-book
  .qw-book__content
  .qw-book__guest-detail
  .qw-book__guest-detail--info
  .qw-book--form-row
  + .qw-book--form-row {
  margin-top: 37px;
  justify-content: space-between;
}

qw-book
  .qw-book__content
  .qw-book__guest-detail
  .qw-book__guest-detail--info
  .qw-book--form-row
  .qw-select__title {
  margin-right: 85px;
}

qw-book
  .qw-book__content
  .qw-book__guest-detail
  .qw-book__guest-detail--info
  .qw-book--form-row
  + .qw-book--form-row
  label {
  font-family: var(--qw-hotel-font-family-m);
  color: var(--qw-hotel-neutral-medium);
  font-size: 16px;
  margin: 0 0 6px;
  flex-direction: column;
  display: flex;
  width: 48%;
}

qw-book
  .qw-book__content
  .qw-book__guest-detail
  .qw-book__guest-detail--info
  .qw-book--form-row
  + .qw-book--form-row
  input {
  padding: 10px 10px 15px;
  font-family: var(--qw-hotel-font-family-m);
  color: var(--qw-hotel-neutral-medium);
  font-size: 20px;
  border: none;
  outline: 1px solid var(--qw-hotel-neutral-light);
  width: 100%;
  margin-top: 6px;
  border: 1px solid #bfc0c0;
}

qw-book .qw-book__content .qw-book__other-info {
  margin: 22px 0 42px;
}

qw-book .qw-book__content .qw-book__guest-detail .qw-book__other-info h3 {
  margin-bottom: 51px;
}

qw-book .qw-book__other-info-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 48px;
}

qw-book .qw-book__other-info-content .qw-select__checkInTime,
qw-book .qw-book__other-info-content .qw-book__special-requests {
  width: 48%;
}
qw-book .qw-book__other-info-content .qw-book__special-requests {
  padding-bottom: 42px;
}

qw-book .qw-book__other-info-content .qw-select__label,
qw-book .qw-book__special-requests .qw-book__special-requests__caption {
  font-family: var(--qw-hotel-font-family-m);
  color: var(--qw-hotel-neutral-medium);
  font-size: 16px;
  margin-bottom: 8px;
}

@media only screen and (max-width: 1400px) {
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    .qw-select__title {
    margin-right: 60px;
  }
  qw-book .qw-input__phone {
    flex-basis: 40%;
  }
  qw-book .qw-book__confirmation qw-input + div {
    padding-left: 12px;
  }
}
@media only screen and (max-width: 1300px) {
  qw-book .qw-input__phone {
    flex-basis: 100%;
  }
  qw-book .qw-input__emailAddress,
  qw-book .qw-book--form-row:last-of-type {
    margin-top: 34px;
  }
  qw-book .qw-book__customer-details-wrapper .qw-select__title {
    flex-basis: 40%;
    width: 40%;
  }
  .qw-book--form-row {
    flex-direction: column;
    align-items: flex-start;
  }
  qw-book .qw-book__customer-details-wrapper .qw-input__firstName {
    margin: 34px 0;
  }
  qw-book .qw-select__countryCode {
    width: 100%;
    margin-top: 34px;
  }
  qw-book .qw-book__guest-details .qw-book__heading,
  qw-book .qw-book__terms .qw-book__heading {
    padding: 24px 32px 25px;
  }
  qw-book .qw-book__customer-details-wrapper {
    padding: 36px 32px 52px;
  }
  qw-book .qw-book__guest-details .qw-book__content,
  qw-book .qw-book__terms .qw-book__content {
    padding: 0 32px 0;
  }
  qw-book .qw-book__content .qw-book__guest-detail {
    margin-bottom: 34px;
    flex-direction: column;
  }
  qw-book .qw-book__other-info-content {
    margin-top: 18px;
    flex-direction: column;
  }
  qw-book .qw-book__content .qw-book__guest-detail h3 {
    margin: 20px 0 28px 0;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info {
    width: 100%;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    + .qw-book--form-row
    label {
    width: 100%;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    + .qw-book--form-row
    label:last-of-type {
    margin-top: 24px;
  }
  qw-book .qw-book__other-info-content .qw-select__checkInTime,
  qw-book .qw-book__other-info-content .qw-book__special-requests {
    width: 100%;
  }
  qw-book .qw-book__other-info-content .qw-select__checkInTime {
    margin-bottom: 24px;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    .qw-select__title {
    flex-basis: 22%;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    .qw-select__Type {
    flex-basis: 30%;
  }
}

@media only screen and (max-width: 1280px) {
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    .qw-select__title {
    margin-right: 20px;
  }
  qw-book .qw-book__customer-details-wrapper h3 {
    font-size: 28px;
  }
  qw-book .qw-book__confirmation qw-input + div {
    padding-left: 10px;
  }

  .qw-book__mandatory-info {
    font-size: 15px;
    margin-bottom: 15px;
  }
  .qw-book--form-row .qw-select__label,
  .qw-book--form-row .qw-select__label,
  .qw-book--form-row .qw-input__label {
    font-size: 18px;
  }
}

@media only screen and (max-width: 1024px) {
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    .qw-select__title {
    margin-right: 14px;
  }
  qw-book .qw-book__customer-details-wrapper h3 {
    font-size: 26px;
  }
}
@media only screen and (max-width: 738px) {
  qw-book .qw-book__customer-details-wrapper {
    padding: 22px 20px 30px;
    box-shadow: none;
    border-radius: 0;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    + .qw-book--form-row
    input {
    padding: 10px 10px 13px;
  }
  qw-book .qw-book__customer-details-wrapper .qw-input__firstName {
    margin: 16px 0;
  }
  qw-book .qw-book__customer-details-wrapper h3 {
    font-size: 20px;
    margin-bottom: 6px;
  }

  .qw-book__mandatory-info {
    font-size: 14px;
    margin: 0 20px 14px;
  }
  .qw-book--form-row {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  qw-book .qw-book__customer-details-wrapper .qw-select__title {
    flex-basis: 40%;
    width: 40%;
    margin-bottom: 24px;
  }
  .qw-book--form-row .qw-select__label,
  .qw-book--form-row .qw-input__label {
    font-size: 15px;
  }
  qw-book .qw-input__emailAddress,
  qw-book .qw-book--form-row:last-of-type {
    margin-top: 0;
  }
  qw-book-guest-detail qw-input {
    margin-bottom: 24px;
  }
  qw-book .qw-book__guest-details,
  qw-book .qw-book__terms {
    margin-top: 24px;
    margin-right: auto;
    margin-left: auto;
    width: calc(100% - 32px);
  }

  qw-book .qw-book__guest-details .qw-book__heading,
  qw-book .qw-book__terms .qw-book__heading {
    padding: 16px;
  }
  qw-book .qw-book__guest-details .qw-book__content,
  qw-book .qw-book__terms .qw-book__content {
    padding: 0 16px;
  }
  qw-book .qw-book__terms .qw-book__content {
    padding: 0 16px 24px;
  }

  qw-book .qw-book__heading h3 {
    font-size: 16px;
  }

  qw-book .qw-select__countryCode {
    margin-top: 0;
  }

  qw-book h3 {
    font-size: 20px;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    + .qw-book--form-row
    input {
    margin-top: 8px;
  }
  qw-book .qw-book__content .qw-book__guest-detail {
    margin: 0 0 16px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  qw-book .qw-book__content .qw-book__guest-detail h3 {
    font-size: 18px;
    margin: 0 0 12px;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    + .qw-book--form-row {
    margin-top: 0;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    .qw-select__title {
    margin-right: 0;
    margin-bottom: 16px;
    min-width: 40%;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    + .qw-book--form-row
    label {
    margin-bottom: 0;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info {
    width: 100%;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    + .qw-book--form-row
    label {
    width: 100%;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    + .qw-book--form-row
    label:last-of-type {
    margin-top: 16px;
  }
  qw-book
    .qw-book__content
    .qw-book__guest-detail
    .qw-book__guest-detail--info
    .qw-book--form-row
    .qw-select__label {
    font-size: 15px;
  }

  qw-book .qw-book__content .qw-book__other-info {
    margin: 24px 0;
  }

  qw-book .qw-book__other-info-content {
    flex-direction: column;
    margin-top: 16px;
  }
  qw-book .qw-book__other-info-content .qw-select__checkInTime,
  qw-book .qw-book__other-info-content .qw-book__special-requests {
    width: 100%;
  }
  qw-book .qw-book__other-info-content .qw-book__special-requests {
    margin-top: 0;
    padding-bottom: 24px;
  }

  qw-book .qw-book__other-info-content qw-textarea {
    min-height: 200px;
  }

  qw-book .qw-book__confirmation {
    margin-top: 24px;
    padding: 0 20px;
  }
  qw-book .qw-book__confirmation qw-input + div {
    font-size: 15px;
    padding-left: 8px;
  }
  .qw-book__confirmation-checkbox + .qw-book__confirmation-checkbox {
    margin-top: 12px;
  }
}
